import React, {
  forwardRef, useEffect, useMemo, useState,
} from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import 'moment-timezone';
import _ from 'lodash';
import MaterialTable, { MTableBody, MTableHeader } from 'material-table';
import { Badge } from 'react-bootstrap';

import { tableIcons,years } from "../../../../helpers";
import {
  ActionColumnProperties, getStickyActionAndStatus,
  localization, objectToCols,
  styledCellSticky, styledHeaderSticky, arrayToLookup, modifyDefaultOptions
} from "../../../../helpers/table";

import { arrayStringRenderer, dateRenderer, floatRenderer } from '../../../../services/formatSvc';

import useAPI from '../../../../hooks/useAPI';
import useUserContext from '../../../../hooks/useUserContext';
import useToast from '../../../../hooks/useToast';
import { isAdmin, isPortfolioTeam, isProjectTeam } from '../../../../services/rolesSvc';
import StatusBadge from '../../../common/StatusBadge';
import ModalSendForRevision from '../../../common/ModalSendForRevision';
import ConfirmModal from '../../../common/ConfirmModal';
import TooltippedElement from '../../../common/TooltippedElement';
import FilterMultiSelect from "../../../table/FilterMultiSelect";

export default function TableProject({ setEditID, filterStatus, year }) {
  const api = useAPI();
  const toast = useToast();
  const history = useHistory();
  const userCtx = useUserContext();
  const { projId, stratId, portfolioId } = useParams();
  const editable = useMemo(() => isAdmin(userCtx) || isPortfolioTeam(userCtx, portfolioId) || isProjectTeam(userCtx, projId), [userCtx]);

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(true);
  const [requests, setRequests] = useState([]);
  const [isModalDelete, setIsModalDelete] = useState({
    show: false,
    value: null,
  });
  const [isModalReject, setIsModalReject] = useState({
    show: false,
    value: null,
  });

  useEffect(async () => {
    await getData();
  }, [filterStatus, year]);

  const getData = async () => {
    try {
      let result = await api.get(
        `/factdata/requests?projId=${projId}&portfId=${portfolioId}&type=rid&status=${filterStatus}`,
      );
      result = result.data;
      if (typeof year === 'number') {
        result = result.filter((e) => e.year == year);
      }
      setRequests(
        result.map((e) => {
          e.isPriorityFinSourceString = e.isPriorityFinSource ? 'Да' : 'Нет';
          return e;
        }),
      );
    } catch (error) {}
  };

  const handleSend = async (id) => {
    const response = await api.post(`/factdata/requests/${id}/send`);
    if (!response.error) {
      const dataCopy = [...requests];
      const tm = dataCopy.find((t) => t.id === id);
      tm.status = 'onApprove';
      setRequests((prev) => dataCopy);
    } else toast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  const handleReject = async (comment) => {
    const response = await api.post(`/factdata/requests/${isModalReject.value}/reject`, { comment });
    if (!response.error) {
      const dataCopy = [...requests];
      const tm = dataCopy.find((t) => t.id === isModalReject.value);
      tm.status = 'rejected';
      tm.comment = comment;
      setRequests((prev) => dataCopy);
      setIsModalReject({ show: false, value: null });
    } else toast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  const handleApprove = async (id) => {
    const response = await api.post(`/factdata/requests/${id}/approve`);
    if (!response.error) {
      const dataCopy = [...requests];
      const tm = dataCopy.find((t) => t.id === id);
      tm.status = 'approved';
      setRequests((prev) => dataCopy);
    } else toast.error(response?.error?.message || 'Не удалось произвести операцию');
  };

  const handleDelete = async () => {
    const result = await api.del(`/factdata/requests/${isModalDelete.value}`, { id: isModalDelete.value });
    if (result && !result.error) {
      toast.success('Заявка успешно удалена');
      setRequests((prev) => prev.filter((v) => v.id !== isModalDelete.value));
    }
    setIsModalDelete({ show: false, value: null });
  };

  const actions = {
    edit: (id, projId) => setEditID(id), // history.replace(`/strats/${stratId}/portfolios/${portfolioId}/projs/${projId}/members/${id}`),
    send: async (id) => await handleSend(id),
    approve: async (id) => await handleApprove(id),
    reject: async (id) => setIsModalReject({ show: true, value: id }),
    delete: async (id) => setIsModalDelete({ show: true, value: id }),
  };

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return (
      <section className="page projects-page">
        <div>Загрузка...</div>
      </section>
    );
  } else {
    return (
      <div className="tab-subproject-register" style={{ color: "initial" }}>
        <div style={styledTable}>
          <MaterialTable
            components={{
              Container: (props) => <div className="special-filter-without-max" {...props} />,
              Body: (props) => (
                  <>
                    <MTableBody {...props}/>
                    <div id="portal-root"></div>
                  </>
              ),
              Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky}/>),
            }}
            title=""
            options={modifyDefaultOptions({
              pageSize: 10,
              pageSizeOptions: [10, 30, 50],
              headerStyle: {
                fontSize: 12,
                lineHeight: 1.3,
                padding: "8px 16px",

                zIndex: 0

              },
              filterCellStyle: {
                position: "sticky",
                top: 48,
                background: 'white',
              },
              filtering: true,
              sorting: true,
              search: false,
              paging: false,
              // headerStyle: { position: "sticky", top: 0 },
              maxBodyHeight: "85vh",
            })}
            icons={tableIcons}
            localization={localization}
            columns={objectToCols([
              ...getStickyActionAndStatus(actions, userCtx, stratId, portfolioId, 'request'),
              {
                title: "№ заявки",
                field: "number",
                cellStyle: { minWidth: "300px" },
                render: (rowData) => (
                  <span onClick={() => setEditID(rowData.id)} style={{ cursor: "pointer", color: "#0D6EFD" }}>
                    {rowData.number}
                  </span>
                ),
              },
              {
                title: "Название заявки",
                field: "name",
                cellStyle: { minWidth: "200px" },
              },
              {
                title: "Авторы",
                field: "authors",
                cellStyle: { minWidth: "200px" },
                render: (rowData) => (
                  <>
                    {rowData.authors.map((e) => (
                      <div>{e.lastName + " " + e.firstName + " " + e.middleName}</div>
                    ))}
                  </>
                ),
                customFilterAndSearch: (term, rowData) => {
                  let authors = rowData.authors.reduce(
                    (prev, cur) => (prev += cur.lastName + cur.firstName + cur.middleName),
                    ""
                  );
                  authors=authors.toLowerCase()
                  return authors.includes(term.toLowerCase());
                },
              },
              {
                title: "Авторы из команды",
                field: "teamMembers",
                cellStyle: { minWidth: "200px" },
                render: (rowData) => (
                  <>
                    {rowData.teamMembers.map((e) => (
                      <div>{e.lastName + " " + e.firstName + " " + e.middleName}</div>
                    ))}
                  </>
                ),
                customFilterAndSearch: (term, rowData) => {
                  let authors = rowData.teamMembers.reduce(
                    (prev, cur) => (prev += cur.lastName + cur.firstName + cur.middleName),
                    ""
                  );
                  authors=authors.toLowerCase()
                  return authors.includes(term.toLowerCase());
                },
              },
              {
                title: "Год подачи заявки",
                field: "year",
                cellStyle: { minWidth: "120px" },
                lookup: arrayToLookup("year", requests),
                filterComponent: FilterMultiSelect,
              },
              {
                title: "РИД получен за счет средств 'Приоритет 2030'",
                field: "isPriorityFinSourceString",
                cellStyle: { minWidth: "120px" },
                lookup: arrayToLookup("isPriorityFinSourceString", requests),
                filterComponent: FilterMultiSelect,
              },
            ])}
            data={requests}
          />
        </div>
      <ModalSendForRevision
        show={isModalReject.show}
        onClose={() => setIsModalReject({ show: false, value: null })}
        onSubmit={(comment) => handleReject(comment)}
        headerText="Не согласовать"
        label="Комментарий"
      />
      <ConfirmModal
        show={isModalDelete.show}
        onClose={() => setIsModalDelete({ show: false, value: null })}
        onConfirm={() => handleDelete()}
        headerText="Удаление заявки"
        message="Заявка будет удалена, данное действие нельзя отменить. Удалить заявку?"
      />
    </div>
  );
}
}

const styledTable = {
  maxWidth: '100%',
};
